import {
  globalConstants,
  userConstants,
} from "../../constants";

const { SUCCESS } = globalConstants;

const { USER_PROFILE } = userConstants;

const initialState = {
  user: {},
};

export const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_PROFILE + SUCCESS:
      return {
        ...state,
        user: action.data,
      };
    default:
      return { ...state };
  }
};
